'use strict';

/**
 *
 * @name: cinematique
 *
 */

import DirectiveTemplate from './nn-player-cinematique.directive.html';

function CinematiqueDirective($sce, $rootScope, localPlaylist, $timeout, $interval) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      videoId: '@'
    },
    link: function(scope, element) {

      var myInterval;
      scope.src = $sce.trustAsResourceUrl('https://cinematique.com/embed/' + scope.videoId);
      var counter, totalTime, firstTimeOnly;

      scope.onMessageReceived = function(event) {

        // possible data values: 'play', 'timeupdate', 'ended'

        if (event.origin.match('cinematique')) {

          if (event.data.event === 'timeupdate') {

            scope.$apply(function() {

              if (totalTime) {

                counter = Math.floor(totalTime - event.data.currentTime);

                if (counter < 0) {

                  counter = 0;
                }

                if (counter < 888888) {

                  localPlaylist.updateCounter(counter);
                }
              }
            });
          } else if (event.data.event === 'play') {

            totalTime = event.data.duration;
          } else if (event.data.event === 'ended' && !firstTimeOnly) {

            $rootScope.noPlayer = true;
            $rootScope.showPersistentVideo = false;
            firstTimeOnly = true;
            $rootScope.$broadcast('filmDun');
          }
        }
      };

      // listen for incoming postmessages from Cinematique
      // W3C
      if (window.addEventListener) {

        window.addEventListener('message', scope.onMessageReceived, false);
      }
      // IE
      else {

        window.attachEvent('onmessage', scope.onMessageReceived);
      }

      var cinematiqueFinishedListener = $rootScope.$on('filmFinished', function() {

        $rootScope.noPlayer = true;
        cinematiqueFinishedListener();
        scope.player.destroy();
        $interval.cancel(myInterval);
        scope.$destroy();
        element.remove();
      });

      scope.$on('$destroy', function() {

        if (myInterval) {

          $interval.cancel(myInterval);
        }

        element.find('*').remove();
        element.remove();
      });
    }
  };
}

export default CinematiqueDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-player-cinematique/nn-player-cinematique.directive.js